import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import Container from "components/Layouts/Container";
import TopBar from "components/Layouts/TopBar";
import Footer from "components/Layouts/Footer";

const Main = ({ children, colorInvert = false, bgColor = "transparent" }) => {
  const theme = useTheme();
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 38,
  });

  return (
    <Box>
      <AppBar
        position={"sticky"}
        sx={{
          top: 0,
          backgroundColor: trigger ? theme.palette.background.paper : bgColor,
        }}
        elevation={trigger ? 0 : 0}
      >
        <Container paddingY={1}>
          <TopBar colorInvert={trigger ? false : colorInvert} />
        </Container>
      </AppBar>
      <main>{children}</main>
      <Container paddingY={0}>
        <Footer />
      </Container>
    </Box>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  colorInvert: PropTypes.bool,
  bgColor: PropTypes.string,
};

export default Main;
